var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useReducer } from "react";
import "./styles.scss";
export default function Notification(_a) {
    var _b = _a.visible, visible = _b === void 0 ? true : _b, _c = _a.alertType, alertType = _c === void 0 ? "success" : _c, _d = _a.action, action = _d === void 0 ? "close" : _d, content = _a.content, onClose = _a.onClose, _e = _a.target, target = _e === void 0 ? "https://matterport.com/" : _e, props = __rest(_a, ["visible", "alertType", "action", "content", "onClose", "target"]);
    var visibilityReducer = function (state, visibility) {
        if (visibility !== null) {
            return visibility;
        }
        return !state;
    };
    /*
     * TODO: It's probably not good to handle closing in here. There's no
     * way to reopen if a new message comes in.
     * Need to remove this functionality, but check if it is
     * being used anywhere other than scheduler
     */
    var _f = useReducer(visibilityReducer, true), isNotificationVisible = _f[0], setNotificationVisibility = _f[1];
    if (!content) {
        return null;
    }
    var handleClose = function () {
        if (onClose) {
            onClose();
            return;
        }
        setNotificationVisibility(null);
    };
    return (_jsx("div", { children: _jsx("div", __assign({ className: "mp-notification ".concat("mp-" + alertType, " ").concat(isNotificationVisible ? "" : "mp-hidden") }, { children: _jsxs("div", __assign({ className: "mp-container" }, { children: [_jsx("p", __assign({ className: action !== "close"
                            ? "mp-hasActionButton mp-description"
                            : "mp-description" }, { children: content })), action === "close" ? (_jsx("button", { onClick: handleClose, className: "mp-button mp-close" })) : (_jsx("a", __assign({ href: target, onClick: handleClose, target: "_blank", className: "mp-button mp-action" }, { children: action })))] })) })) }));
}
